export default __webpack_public_path__ + "static/dustin-bitmoji-33da80ac7f816dc622b6a94291ae5c67.png";